import React, { ComponentType, ReactNode, useMemo } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import { TOOL_IDS } from './consts';

export type ToolIdsType = typeof TOOL_IDS;
export type ToolIdType = ToolIdsType[keyof ToolIdsType];

type CurrentToolIdContextType = {
  toolId?: ToolIdType;
};

/**
 * Context for current tool ID.
 */
const CurrentToolIdContext = getOrCreateGlobalContext<CurrentToolIdContextType>(
  CONTEXT_NAMES.CurrentToolIdContext,
);

const useCurrentToolIdContext = () =>
  useContextWithValidation(CurrentToolIdContext, {
    hook: 'useCurrentToolIdContext',
    provider: 'CurrentToolIdProvider',
  });

export const useCurrentToolId = () => {
  const currentToolIdContext = useCurrentToolIdContext();
  return currentToolIdContext?.toolId;
};

type CurrentToolIdProviderProps = {
  toolId?: ToolIdType;
  children: ReactNode;
};

export const CurrentToolIdProvider: ComponentType<
  CurrentToolIdProviderProps
> = ({ children, toolId }) => {
  const value = useMemo(() => {
    return { toolId };
  }, [toolId]);
  return (
    <CurrentToolIdContext.Provider value={value}>
      {children}
    </CurrentToolIdContext.Provider>
  );
};

CurrentToolIdProvider.displayName = 'CurrentToolIdProvider';
